import { Container, IDestroyOptions, Texture, Ticker } from "pixi.js";
import { Emitter, EmitterConfigV2, upgradeConfig } from "@pixi/particle-emitter";

export class MyWalletParticleView extends Container {
    private readonly emitter: Emitter;
    private readonly particlesLifetimeMs: number;

    private animationTimeMs: number;

    public constructor(config: EmitterConfigV2, textures: Array<Texture>) {
        super();
        const configV3 = upgradeConfig(config, textures);
        this.emitter = new Emitter(this, upgradeConfig(configV3, textures));
        this.animationTimeMs = 0;
    }

    public async play(): Promise<void> {
        this.emitter.autoUpdate = true;
        Ticker.shared.add(this.updateTime, this);
    }

    private updateTime(): void {
        this.animationTimeMs += Ticker.shared.elapsedMS;
        if (this.animationTimeMs >= this.particlesLifetimeMs) {
            this.emitter.autoUpdate = false;
            Ticker.shared.remove(this.updateTime, this);
        }
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.emitter.autoUpdate = false;
        Ticker.shared.remove(this.updateTime, this);
        super.destroy(options);
    }
}
